import { render, staticRenderFns } from "./ModalCourse.vue?vue&type=template&id=8ec0e7ba&scoped=true"
import script from "./ModalCourse.vue?vue&type=script&lang=ts"
export * from "./ModalCourse.vue?vue&type=script&lang=ts"
import style0 from "./ModalCourse.scss?vue&type=style&index=0&id=8ec0e7ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec0e7ba",
  null
  
)

export default component.exports